import React from "react";
import "../styles/Header.css";

const Header = ({ children, className, tag: Tag = "div", ...rest }) => (
  <Tag className={`header ${className || ""}`} {...rest}>
    {children}
  </Tag>
);

export default Header;

